$(document).on('click', '.quantity-btn-plus', function(e) {
  e.preventDefault();
  var $this = $(this);
  var $input = $this.closest('.quantity').find('.quantity-btn-number');
  var currentVal = parseInt($input.val());
  if (!isNaN(currentVal)) {
    $input.val(currentVal + 1);
  } else {
    $input.val(1);
  }
  $input.trigger('change');
});

$(document).on('click', '.quantity-btn-minus', function(e) {
  e.preventDefault();
  var $this = $(this);
  var $input = $this.closest('.quantity').find('.quantity-btn-number');
  var currentVal = parseInt($input.val());
  if (!isNaN(currentVal) && currentVal > 1) {
    $input.val(currentVal - 1);
  } else {
    $input.val(1);
  }
  $input.trigger('change');
});
